module.exports = __webpack_public_path__ + "img/cancel-icon-accent.3f3fb5dd.svg";